const PropertyCardHeader = ({Icon, title, desc}: {Icon: any, title: string, desc: string}) => {
  return (
    <div className="flex flex-row gap-3 items-center">
      <div className="h-[38px] w-[38px] rounded-full bg-primary flex items-center justify-center p-[10px]">
        <Icon className="stroke-white"/>
      </div>
      <div className="flex flex-col">
        <span className="text-[16px] font-semibold">{title}</span>
        <span className="text-[12px]">{desc}</span>
      </div>
    </div>
  )
}

export default PropertyCardHeader;